import { getTnaSummaryStatus } from "components/TAndA/NewSummary/tnaSummaryUtils";

/** Shape table rows like legacy Todo list: grouped by due date. */
export function transformNewTodoListData(apiRows) {
  const byDueDate = {};

  (apiRows || []).forEach((styleRow) => {
    (styleRow.tna_style_tasks || []).forEach((taskRow) => {
      const dueDate = taskRow.due_date || "";
      if (!byDueDate[dueDate]) {
        byDueDate[dueDate] = { date: dueDate, data: [] };
      }

      let nested = byDueDate[dueDate].data.find(
        (d) =>
          d.id === styleRow.sales_contract_id &&
          d.style_id === styleRow.style_id,
      );

      if (!nested) {
        nested = {
          id: styleRow.sales_contract_id,
          style_id: styleRow.style_id,
          reference_no: styleRow.sales_contract?.reference_no,
          buyer: styleRow.buyer,
          buying_office: styleRow.buying_office,
          tna_plan_task: [],
        };
        byDueDate[dueDate].data.push(nested);
      }

      nested.tna_plan_task.push({
        id: taskRow.id,
        title: taskRow.task?.title,
        responsible_person_name: taskRow.responsible_person?.name,
        task_dates: [
          {
            id: taskRow.id,
            due_date: taskRow.due_date,
            status: getTnaSummaryStatus(taskRow.due_date),
            action_status_string: taskRow.action_status,
            comment: taskRow.comment,
            held_status_comment: taskRow.comment,
            styles: styleRow.styles?.length
              ? styleRow.styles.map((style) => ({ style_no: style.style_no }))
              : styleRow.style?.style_no
              ? [{ style_no: styleRow.style.style_no }]
              : [],
            purchase_order_maps: [],
          },
        ],
      });
    });
  });

  return Object.keys(byDueDate)
    .sort()
    .map((key) => byDueDate[key]);
}
